import SwiperJS, { Navigation, Pagination } from 'swiper';
// eslint-disable-next-line import/no-relative-packages
import '../../../node_modules/swiper/swiper-bundle.min.css';
import isMobileBrowser from '../utils/isMobileBrowser';

const SCREEN_1024 = 1024;
const SCREEN_1440 = 1440;
const SCREEN_1920 = 1920;

// To use Swiper, add 'swiper-container-{unique id}' class to the containers besides 'swiper' class.
// Also use the same unique id for the pagination element, and it's control buttons.
// Example: <div class="swiper swiper-container-1234"></div>
//          <div class="swiper-pagination swiper-pagination-1234"></div>
//          <div class="swiper-button-prev swiper-button-prev-1234"></div>

export default class Swiper {
  constructor(containerClass = '.swiper') {
    this.containerClass = `${containerClass}`;
    this.swiper = [];
    this.config = {
      modules: [Pagination, Navigation],
      loop: true,
      watchSlidesVisibility: true,
      longSwipes: false,
      preloadImages: false,
      slidesPerView: 1,
      spaceBetween: 32,
      centeredSlides: true,
      breakpoints: {
        [SCREEN_1024]: {
          slidesPerView: 3,
          centeredSlides: true,
          slideToClickedSlide: true
        },
        [SCREEN_1440]: {
          slidesPerView: 3
        },
        [SCREEN_1920]: {
          slidesPerView: 5
        }
      }
    };
  }

  initialize() {
    const containers = document.querySelectorAll('[class*=swiper-container]');

    if (!containers.length) return;

    [...containers].forEach((container) => {
      const { swiperId } = container.dataset;
      const navigationConfig = {
        pagination: {
          el: `.swiper-pagination-${swiperId}`,
          type: 'fraction',
          renderFraction(currentClass, totalClass) {
            return `<span class="${currentClass}"></span>
                  of
                  <span class="${totalClass}"></span>`;
          }
        },
        navigation: {
          nextEl: `.pagination-button-next-${swiperId}`,
          prevEl: `.pagination-button-prev-${swiperId}`
        }
      };

      const isLoopEnabled = JSON.parse(container.dataset.enableLoop);
      const isAutoHeightEnabled = JSON.parse(container.dataset.enableAutoHeight);
      const isMobileDevice = isMobileBrowser();

      const config = {
        ...this.config,
        ...navigationConfig,
        loop: isLoopEnabled,
        watchOverflow: true,
        ...isMobileDevice && isAutoHeightEnabled && { autoHeight: true }
      };

      this.swiper.push(new SwiperJS(container, config));
    });
  }
}
